import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import {
  getUsageTableFilterChipLink,
  UsageTableFilterChipLink,
} from "../../../helpers/usage/usageTableFilterHelpers";

interface UsageTableFilterChipProps {
  label: string;
  statusKey?: string | null;
  onClear: () => void;
  onNavigateToFocus: (link: UsageTableFilterChipLink) => void;
}

function UsageTableFilterChip({
  label,
  statusKey,
  onClear,
  onNavigateToFocus,
}: UsageTableFilterChipProps) {
  const { t } = useTranslation();
  const link = getUsageTableFilterChipLink(statusKey);

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
      <span>
        {t("Analytics.Widgets.Usage.TableFilter.Showing", "Showing:")}{" "}
        <span className="font-semibold text-gray-800">{label}</span>
      </span>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded border border-gray-300 bg-white px-2 py-0.5 text-xs font-medium text-gray-600 hover:border-primary hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)]"
        onClick={onClear}
      >
        <FontAwesomeIcon icon={faTimes} aria-hidden />
        {t("Common.Clear", "Clear")}
      </button>
      <button
        type="button"
        className="text-xs font-semibold text-primary hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)]"
        onClick={() => onNavigateToFocus(link)}
      >
        {link === "managers"
          ? t(
              "Analytics.Widgets.Usage.TableFilter.SeeManagers",
              "See which managers →",
            )
          : t(
              "Analytics.Widgets.Usage.TableFilter.SeeBreakdown",
              "See breakdown →",
            )}
      </button>
    </div>
  );
}

export default UsageTableFilterChip;
